/* ==========================================================================
   DRIONA — local ring sizes
   Added 29 Sep 2026. Used by the ring buy box (sections/dj-prod-main.liquid)
   and the sizing page (sections/dj-ring-size.liquid).

   Every size, in every system, is reduced to ONE number: the inside
   circumference in millimetres. Conversions go through that number, never
   from one local scale straight to another, so no table can drift out of
   step with the others.

   The workshop always receives a US size plus the millimetre figure, e.g.
   "UK N½ = US 7 (54.4 mm)", so nobody has to convert anything by hand.
   ========================================================================== */
(function () {
  if (window.DJRing) return;

  /* US size s has an inside diameter of 11.63 + 0.8128·s mm (the standard
     US scale: 0.8128 mm per full size). Circumference is π × that. */
  function usToMm(us) {
    return (11.63 + 0.8128 * us) * Math.PI;
  }
  function mmToUs(mm) {
    return (mm / Math.PI - 11.63) / 0.8128;
  }
  function quarter(x) {
    return Math.round(x * 4) / 4;
  }
  function fmtUs(us) {
    return String(quarter(us)); // 7, 7.25, 7.5, 7.75
  }
  function fmtMm(mm) {
    return mm.toFixed(1);
  }
  function diameter(mm) {
    return mm / Math.PI;
  }

  /* UK / Australia / Ireland / NZ letters, anchored to the US quarter sizes
     used by the industry charts. I½ has no US quarter of its own (the letter
     scale runs slightly finer than the US one), so it sits halfway. */
  var UK = [
    ['F', 3], ['F½', 3.25], ['G', 3.5], ['G½', 3.75], ['H', 4], ['H½', 4.25],
    ['I', 4.5], ['I½', 4.625], ['J', 4.75], ['J½', 5], ['K', 5.25], ['K½', 5.5],
    ['L', 5.75], ['L½', 6], ['M', 6.25], ['M½', 6.5], ['N', 6.75], ['N½', 7],
    ['O', 7.25], ['O½', 7.5], ['P', 7.75], ['P½', 8], ['Q', 8.25], ['Q½', 8.5],
    ['R', 8.75], ['R½', 9], ['S', 9.25], ['S½', 9.5], ['T', 9.75], ['T½', 10],
    ['U', 10.25], ['U½', 10.5], ['V', 10.75], ['V½', 11], ['W', 11.25], ['W½', 11.5],
    ['X', 11.75], ['X½', 12], ['Y', 12.25], ['Y½', 12.5], ['Z', 12.75], ['Z½', 13]
  ];

  /* The five scales. `name` is what the switcher shows; `code` prefixes the
     size on the order. it/jp are both "circumference minus 40" scales but are
     kept apart so each customer recognises their own country in the list. */
  var SYSTEMS = {
    us: { code: 'US', name: 'US & Canada', short: 'US sizes' },
    uk: { code: 'UK', name: 'UK, Ireland, Australia & NZ', short: 'UK & AU sizes' },
    eu: { code: 'EU', name: 'Europe (FR, DE, NL, PL, Nordics…)', short: 'EU sizes' },
    it: { code: 'IT', name: 'Italy, Spain & Switzerland', short: 'IT · ES · CH sizes' },
    jp: { code: 'JP', name: 'Japan, Korea, China & India', short: 'JP · Asia sizes' }
  };
  var ORDER = ['us', 'uk', 'eu', 'it', 'jp'];

  var COUNTRY = {
    uk: 'GB IE AU NZ ZA IM JE GG',
    eu: 'FR DE AT BE NL LU PL CZ SK SE DK NO FI IS PT HU RO GR EE LV LT SI HR BG MC LI',
    it: 'IT ES CH SM VA AD',
    jp: 'JP KR CN HK TW IN'
  };

  function systemFor(country) {
    country = String(country || '').toUpperCase();
    for (var key in COUNTRY) {
      if ((' ' + COUNTRY[key] + ' ').indexOf(' ' + country + ' ') !== -1) return key;
    }
    return 'us';
  }

  /* The prefix on the order. A Spanish customer is told "ES 14", not "IT 14";
     someone who picked the Italian scale from elsewhere gets "IT 14". */
  function codeFor(sys, country) {
    country = String(country || '').toUpperCase();
    if ((sys === 'it' || sys === 'jp') && systemFor(country) === sys) return country;
    return SYSTEMS[sys].code;
  }

  var cache = {};
  function sizes(sys) {
    if (cache[sys]) return cache[sys];
    var list = [];
    var i;
    if (sys === 'us') {
      for (i = 3; i <= 13.0001; i += 0.25) list.push({ local: fmtUs(i), mm: usToMm(i) });
    } else if (sys === 'uk') {
      UK.forEach(function (r) { list.push({ local: r[0], mm: usToMm(r[1]) }); });
    } else if (sys === 'eu') {
      for (i = 44; i <= 70; i++) list.push({ local: String(i), mm: i });
    } else {
      for (i = 4; i <= 30; i++) list.push({ local: String(i), mm: i + 40 });
    }
    list.forEach(function (s) { s.us = mmToUs(s.mm); s.sys = sys; });
    return (cache[sys] = list);
  }

  function nearest(sys, mm) {
    var best = null;
    sizes(sys).forEach(function (s) {
      if (!best || Math.abs(s.mm - mm) < Math.abs(best.mm - mm)) best = s;
    });
    return best;
  }

  /* What goes on the order. US customers get the plain size they asked for;
     everyone else gets their own size first, then what the workshop needs. */
  function orderValue(s, country) {
    var code = codeFor(s.sys, country);
    if (s.sys === 'us') return 'US ' + s.local;
    return code + ' ' + s.local + ' = US ' + fmtUs(s.us) + ' (' + fmtMm(s.mm) + ' mm)';
  }

  function optionText(s) {
    if (s.sys === 'us') return s.local + '  (' + fmtMm(s.mm) + ' mm)';
    if (s.sys === 'eu') return s.local + '  (US ' + fmtUs(s.us) + ')';
    return s.local + '  (US ' + fmtUs(s.us) + ' · ' + fmtMm(s.mm) + ' mm)';
  }

  window.DJRing = {
    SYSTEMS: SYSTEMS,
    ORDER: ORDER,
    systemFor: systemFor,
    codeFor: codeFor,
    sizes: sizes,
    nearest: nearest,
    usToMm: usToMm,
    mmToUs: mmToUs,
    diameter: diameter,
    fmtUs: fmtUs,
    fmtMm: fmtMm,
    orderValue: orderValue,
    optionText: optionText
  };

  /* ========================================================================
     BUY BOX
     The section renders a working US list, so the field still posts a size
     if this script never runs. With it, the list is rebuilt in the visitor's
     own scale, and the "confirm later" choice is wired up.
     ======================================================================== */

  var TBC = 'To be confirmed – we will email you before making';

  function initBuyBox(wrap) {
    if (!wrap || wrap.__djRing) return;
    wrap.__djRing = true;

    var select = wrap.querySelector('[data-djp-size-select]');
    var sysSelect = wrap.querySelector('[data-djp-rs-sys]');
    var label = wrap.querySelector('[data-djp-size-value]');
    var later = wrap.querySelector('[data-djp-rs-later]');
    var laterNote = wrap.querySelector('[data-djp-rs-later-note]');
    var err = wrap.querySelector('[data-djp-size-err]');
    if (!select) return;

    var country = wrap.getAttribute('data-djp-rs-country') || '';
    var placeholder = wrap.getAttribute('data-djp-rs-placeholder') || 'Choose a size';
    var sys = (sysSelect && sysSelect.value) || systemFor(country);
    var chosenMm = null; // survives a change of scale

    function setLabel(text) {
      if (label) label.textContent = text;
    }

    function build() {
      var frag = document.createDocumentFragment();
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = placeholder;
      frag.appendChild(ph);
      var pick = chosenMm == null ? null : nearest(sys, chosenMm);
      sizes(sys).forEach(function (s) {
        var o = document.createElement('option');
        o.value = orderValue(s, country);
        o.textContent = optionText(s);
        o.setAttribute('data-mm', s.mm);
        o.setAttribute('data-short', codeFor(sys, country) + ' ' + s.local);
        if (pick === s) o.selected = true;
        frag.appendChild(o);
      });
      select.innerHTML = '';
      select.appendChild(frag);
      if (!pick) select.value = '';
      if (later && later.checked) addTbc();
      syncLabel();
    }

    function addTbc() {
      if (!select.querySelector('[data-djp-rs-tbc]')) {
        var o = document.createElement('option');
        o.value = TBC;
        o.textContent = 'To be confirmed';
        o.setAttribute('data-djp-rs-tbc', '');
        select.appendChild(o);
      }
      select.value = TBC;
    }

    function syncLabel() {
      if (later && later.checked) return setLabel('To be confirmed');
      var o = select.options[select.selectedIndex];
      setLabel(o && o.value ? o.getAttribute('data-short') : placeholder);
    }

    select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex];
      if (o && o.value && o.getAttribute('data-mm')) chosenMm = parseFloat(o.getAttribute('data-mm'));
      // dj-product-2.js writes the raw value into the label on the same event;
      // run after it so the short form ("UK N½") wins.
      setTimeout(syncLabel, 0);
    });

    if (sysSelect) {
      sysSelect.addEventListener('change', function () {
        sys = sysSelect.value;
        build();
      });
    }

    if (later) {
      later.addEventListener('change', function () {
        var on = later.checked;
        wrap.classList.toggle('is-later', on);
        if (laterNote) laterNote.hidden = !on;
        if (on) {
          addTbc();
          wrap.classList.remove('is-bad');
          if (err) err.classList.add('djp-hidden');
        } else {
          var t = select.querySelector('[data-djp-rs-tbc]');
          if (t) t.remove();
          var pick = chosenMm == null ? null : nearest(sys, chosenMm);
          select.value = pick ? orderValue(pick, country) : '';
        }
        syncLabel();
      });
    }

    build();
    wrap.classList.add('is-ready');
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-djp-rs]').forEach(initBuyBox);
    (root || document).querySelectorAll('[data-djrs-page]').forEach(initPage);
  }

  /* ========================================================================
     SIZING PAGE
     Three ways in — "I know my size", "measure a ring", "measure my finger" —
     all resolving to one circumference, then shown in every scale with the
     visitor's own scale first.
     ======================================================================== */

  function initPage(root) {
    if (!root || root.__djRing) return;
    root.__djRing = true;

    var country = root.getAttribute('data-country') || '';
    var home = systemFor(country);
    var tabs = root.querySelectorAll('[data-djrs-tab]');
    var panes = root.querySelectorAll('[data-djrs-pane]');
    var result = root.querySelector('[data-djrs-result]');
    var knowSys = root.querySelector('[data-djrs-know-sys]');
    var knowSize = root.querySelector('[data-djrs-know-size]');
    var ringIn = root.querySelector('[data-djrs-ring]');
    var fingerIn = root.querySelector('[data-djrs-finger]');
    var table = root.querySelector('[data-djrs-table]');

    function order() {
      return [home].concat(ORDER.filter(function (k) { return k !== home; }));
    }

    /* ---- tabs ---- */
    function show(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-djrs-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panes.forEach(function (p) { p.hidden = p.getAttribute('data-djrs-pane') !== name; });
      clearResult();
      if (name === 'know') fromKnow();
      if (name === 'ring') fromRing();
      if (name === 'finger') fromFinger();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.getAttribute('data-djrs-tab')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus();
        n.click();
      });
    });

    /* ---- "I know my size" ---- */
    function fillKnowSizes() {
      if (!knowSys || !knowSize) return;
      var sys = knowSys.value;
      var html = '<option value="">Choose your size</option>';
      sizes(sys).forEach(function (s, i) {
        html += '<option value="' + i + '">' + codeFor(sys, country) + ' ' + s.local + '</option>';
      });
      knowSize.innerHTML = html;
    }
    function fromKnow() {
      if (!knowSys || !knowSize || knowSize.value === '') return clearResult();
      render(sizes(knowSys.value)[+knowSize.value].mm, 'Your size');
    }
    if (knowSys) {
      knowSys.innerHTML = order().map(function (k) {
        return '<option value="' + k + '">' + SYSTEMS[k].name + '</option>';
      }).join('');
      knowSys.value = home;
      fillKnowSizes();
      knowSys.addEventListener('change', function () { fillKnowSizes(); clearResult(); });
      knowSize.addEventListener('change', fromKnow);
    }

    /* ---- measurements ---- */
    function num(input) {
      var v = parseFloat(String(input.value).replace(',', '.'));
      return isFinite(v) ? v : null;
    }
    function fromRing() {
      if (!ringIn) return;
      var d = num(ringIn);
      if (d == null) return clearResult();
      if (d < 13.5 || d > 23) return message('That looks outside ring sizes — the inside diameter of most rings is between 14 and 22 mm.');
      render(d * Math.PI, 'A ring ' + d + ' mm across fits');
    }
    function fromFinger() {
      if (!fingerIn) return;
      var c = num(fingerIn);
      if (c == null) return clearResult();
      if (c < 42 || c > 72) return message('That looks outside ring sizes — most fingers measure between 44 and 70 mm around.');
      render(c, 'A ' + c + ' mm finger takes');
    }
    if (ringIn) ringIn.addEventListener('input', fromRing);
    if (fingerIn) fingerIn.addEventListener('input', fromFinger);

    /* ---- result card ---- */
    function clearResult() {
      if (!result) return;
      result.hidden = true;
      result.innerHTML = '';
      highlight(null);
    }
    function message(text) {
      if (!result) return;
      result.hidden = false;
      result.innerHTML = '<p class="djrs-result__msg">' + text + '</p>';
      highlight(null);
    }
    function render(mm, lead) {
      if (!result) return;
      var main = nearest(home, mm);
      var rows = order().map(function (k) {
        var s = nearest(k, mm);
        return '<div class="djrs-result__row' + (k === home ? ' is-home' : '') + '">' +
          '<dt>' + SYSTEMS[k].name + '</dt><dd>' + codeFor(k, country) + ' ' + s.local + '</dd></div>';
      }).join('');
      result.hidden = false;
      result.innerHTML =
        '<p class="djrs-result__lead">' + lead + '</p>' +
        '<p class="djrs-result__size">' + codeFor(home, country) + ' ' + main.local + '</p>' +
        '<p class="djrs-result__mm">' + fmtMm(mm) + ' mm around · ' + fmtMm(diameter(mm)) + ' mm across</p>' +
        '<dl class="djrs-result__list">' + rows + '</dl>' +
        '<p class="djrs-result__tip">Between two sizes, or choosing a band wider than 6 mm? Go up a quarter size.</p>';
      highlight(mm);
    }

    /* ---- full chart ---- */
    function buildTable() {
      if (!table) return;
      var cols = order();
      var head = '<tr>' + cols.map(function (k) {
        return '<th scope="col"' + (k === home ? ' class="is-home"' : '') + '>' + SYSTEMS[k].short.replace(' sizes', '') + '</th>';
      }).join('') + '<th scope="col">Around (mm)</th><th scope="col">Across (mm)</th></tr>';
      var body = '';
      sizes('us').forEach(function (u) {
        body += '<tr data-mm="' + u.mm + '">' + cols.map(function (k) {
          var s = k === 'us' ? u : nearest(k, u.mm);
          return '<td' + (k === home ? ' class="is-home"' : '') + '>' + s.local + '</td>';
        }).join('') + '<td>' + fmtMm(u.mm) + '</td><td>' + fmtMm(diameter(u.mm)) + '</td></tr>';
      });
      table.innerHTML = '<thead>' + head + '</thead><tbody>' + body + '</tbody>';
    }
    function highlight(mm) {
      if (!table) return;
      var best = null;
      table.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.classList.remove('is-match');
        if (mm == null) return;
        var d = Math.abs(parseFloat(tr.getAttribute('data-mm')) - mm);
        if (!best || d < best.d) best = { tr: tr, d: d };
      });
      if (best) best.tr.classList.add('is-match');
    }

    buildTable();
    root.classList.add('is-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
